import { createSelector } from "reselect";
import { getPageContent } from "shared/selectors/base";

// eslint-disable-next-line import/prefer-default-export
export const getProjectDataExports = createSelector(
  [getPageContent],
  pageContent => pageContent?.project_data_exports || []
);
